/**
 * Utilities and constants for CRM Tasks and Follow-ups
 */

export function getCompanyId() {
  try {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      const userObj = JSON.parse(storedUser);
      return userObj?.company_id || localStorage.getItem('company_id');
    }
  } catch (e) {
    console.error('Failed to parse user object from localStorage', e);
  }
  return localStorage.getItem('company_id');
}

export function formatDate(dateStr) {
  if (!dateStr) return 'N/A';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  } catch {
    return dateStr;
  }
}

export function formatDateTime(dateStr) {
  if (!dateStr) return 'N/A';
  try {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch {
    return dateStr;
  }
}

export function getStatusChipTone(status) {
  const s = String(status || '')
    .toLowerCase()
    .trim();
  if (s === 'completed' || s === 'done') return 'success';
  if (s === 'active' || s === 'upcoming' || s === 'running') return 'info';
  if (s === 'paused') return 'warning';
  if (s === 'failed' || s === 'cancelled') return 'error';
  return 'neutral';
}

export const TASK_FOLLOWUP_STATUS_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'completed', label: 'Completed' },
  { value: 'paused', label: 'Paused' },
];

export function getFollowUpStatusChipStyle(status) {
  const s = String(status || '')
    .toLowerCase()
    .trim();
  if (s === 'active' || s === 'running' || s === 'completed') {
    return {
      style: {
        color: '#50AB3D',
        backgroundColor: '#EBF4EA',
        borderColor: '#C5E3BF',
      },
    };
  }
  if (s === 'paused') {
    return {
      style: {
        color: '#EEB90B',
        backgroundColor: '#FAF6E6',
        borderColor: '#F5E9C5',
      },
    };
  }
  if (s === 'stopped' || s === 'cancelled' || s === 'failed') {
    return {
      style: {
        color: '#FF383C',
        backgroundColor: '#FCEAEC',
        borderColor: '#FCEAEC',
      },
    };
  }
  if (s === 'scheduled') {
    return {
      style: {
        color: '#0088FF',
        backgroundColor: '#EEF5FB',
        borderColor: '#EEF5FB',
      },
    };
  }
  return {
    style: {
      color: '#868686',
      backgroundColor: '#F5F5F5',
      borderColor: '#E0E0E0',
    },
  };
}
